import { z } from "zod";

const config = z.object({
  VITE_BASE_API_URL: z.string(),
  VITE_BASE_URL: z.string(),
  VITE_BILLING_URL: z.string(),
  VITE_INTERCOM_APP_ID: z.string(),
  VITE_PHP_URL: z.string().default("http://localhost"),
  VITE_PUBLIC_POSTHOG_HOST: z.string(),
  VITE_PUBLIC_POSTHOG_KEY: z.string(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SENTRY_ENVIRONMENT: z.string().default("local"),
  VITE_SLACK_SUPRSEND_CLIENT_ID: z.string(),
  VITE_STRIPE_ACCOUNT: z.string().optional(),
  VITE_STRIPE_BILLING_TOKEN: z.string(),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string(),
  VITE_SUPRSEND_PUBLIC_KEY: z.string(),
  VITE_SUPRSEND_VAPID_KEY: z.string(),
});

export const env = config.parse(import.meta.env);
